import { Card } from '@/lib';
import { useTranslation } from 'react-i18next';

export const Skeleton = () => {
  const { t } = useTranslation('marketIntelligence');

  return (
    <div className='w-full space-y-5' role='status' aria-busy='true' aria-live='polite'>
      <span className='sr-only'>{t('report.loading.title')}</span>
      <Card className='w-full block border-primary-border bg-white p-6 drop-shadow-none'>
        <div className='grid gap-4 sm:grid-cols-2 xl:grid-cols-4'>
          {Array.from({ length: 4 }).map((_, i) => (
            <div key={i} className='space-y-2'>
              <div className='h-4 w-28 animate-pulse rounded-lg bg-foreground-disabled-subtle' />
              <div className='h-3 w-20 animate-pulse rounded-lg bg-foreground-disabled-subtle' />
            </div>
          ))}
        </div>
      </Card>

      <div className='grid w-full grid-cols-1 gap-5 md:grid-cols-2'>
        {Array.from({ length: 2 }).map((_, i) => (
          <Card key={i} className='block space-y-4 border-primary-border bg-white p-5 drop-shadow-none'>
            <div className='h-7 w-48 animate-pulse rounded-lg bg-foreground-disabled-subtle' />
            <div className='h-4 w-full max-w-sm animate-pulse rounded-lg bg-foreground-disabled-subtle' />
            <div className='space-y-3'>
              {Array.from({ length: 3 }).map((_, j) => (
                <div key={j} className='h-16 w-full animate-pulse rounded-lg bg-foreground-disabled-subtle' />
              ))}
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
};
